import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDEpeKRZMqdB7I-56XobPcqRnthbdKbNes",
  authDomain: "reality-connect-website.firebaseapp.com",
  projectId: "reality-connect-website",
  storageBucket: "reality-connect-website.appspot.com",
  messagingSenderId: "840632831971",
  appId: "1:840632831971:web:29f0a5517d14f07edb1ad6",
  measurementId: "G-EH12X38KMP",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
